export const setSelectedRestaurant = (data) => ({
    type: 'SET_SELECTED_RESTAURANT',
    data
});
